import { takeEvery } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import fetcher from 'modules/fetcher'

import {
  calendarEntryStatusCreate,
  calendarEntryStatusCreateFailure,
  calendarEntryStatusUpdate,
  calendarEntryStatusUpdateFailure,
  calendarEntryStatusDelete,
  calendarEntryStatusDeleteFailure
} from '../actions'

import {
  CALENDAR_ENTRY_STATUS_CREATE_SUBMIT,
  CALENDAR_ENTRY_STATUS_UPDATE_SUBMIT,
  CALENDAR_ENTRY_STATUS_DELETE_SUBMIT
} from '../constants'

export function * calendarEntryStatusCreateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      'api/v3/admin/calendar_entry_statuses',
      {
        method: 'POST',
        body: JSON.stringify({
          calendar_entry_status: {
            name: payload.name,
            hex_color: payload.hexColor
          }
        })
      }
    )
    yield put(calendarEntryStatusCreate(response))
  } catch (exception) {
    console.error(exception.message)
    yield put(calendarEntryStatusCreateFailure(exception.message))
  }
}

export function * watchCalendarEntryStatusCreateSaga () {
  yield call(takeEvery, CALENDAR_ENTRY_STATUS_CREATE_SUBMIT, calendarEntryStatusCreateSaga)
}

export function * calendarEntryStatusUpdateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      `api/v3/admin/calendar_entry_statuses/${payload.id}`,
      {
        method: 'PUT',
        body: JSON.stringify({
          calendar_entry_status: {
            name: payload.name,
            hex_color: payload.hexColor
          }
        })
      }
    )
    yield put(calendarEntryStatusUpdate(response))
  } catch (exception) {
    yield put(calendarEntryStatusUpdateFailure(exception.message))
  }
}

export function * watchCalendarEntryStatusUpdateSaga () {
  yield call(takeEvery, CALENDAR_ENTRY_STATUS_UPDATE_SUBMIT, calendarEntryStatusUpdateSaga)
}

export function * calendarEntryStatusDeleteSaga ({ payload }) {
  try {
    yield call(
      fetcher,
      `api/v3/admin/calendar_entry_statuses/${payload.id}`,
      {
        method: 'DELETE',
        body: JSON.stringify({})
      }
    )
    yield put(calendarEntryStatusDelete(payload))
  } catch (exception) {
    yield put(calendarEntryStatusDeleteFailure(exception.message))
  }
}

export function * watchCalendarEntryStatusDeleteSaga () {
  yield call(takeEvery, CALENDAR_ENTRY_STATUS_DELETE_SUBMIT, calendarEntryStatusDeleteSaga)
}
